/**
 * Map sidebar filters for GET /api/resources (API Platform property names, camelCase).
 */
export interface ResourceMapFilters {
  type: string
  administrativeScopes: string
  thematics: string
}

export function createEmptyResourceMapFilters(): ResourceMapFilters {
  return {
    type: '',
    administrativeScopes: '',
    thematics: '',
  }
}
